import BaseAction from "@common/redux/actions/BaseAction";
import CustomerReducer from "@common/redux/reducers/CustomerReducer";

class CustomerAction extends BaseAction {
  set = async (loading) => this.dispatch({ loading });
}

const action = new CustomerAction(CustomerReducer);

export default action;
